import { useState } from "react";
import styles from "./CurrentRoute.module.scss";
import { ReactComponent as ExpandIcon } from "assets/expand.svg";
import { store } from 'stores/Store';
import React from "react";
import useExternalApiService from "helpers/ExternalApiService";
import { ReactComponent as HouseIcon } from "assets/house.svg";
import { ReactComponent as FlagIcon } from "assets/flag.svg";
import MeetingModal from "./components/MeetingModal";
import RoutesTab from "Modules/PractitionerBaseballCard/components/RoutesTab";

interface IMapRouterProps {
  currentRoute: any;
  onRouteChange: (v: number) => void;
}

interface Waypoint {
  travelTime?: number;
  id?: number;
  address?: string;
  latitude?: string;
  longitude?: string;
  isFirstLocation?: boolean;
  isLastLocation?: boolean;
  start_time?: string;
  duration?: string;
  end_time?: string;
  arriveTime?: string;
  name?: string;
}

const parseStartTime = (startTime: string) => {
  if (!startTime) return "";
  if (startTime.includes("AM") || startTime.includes("PM")) {
    const [time, period] = startTime.split(' ');
    const [hours, minutes] = time.split(':').map(Number);
    const isPM = period === 'PM';
    const adjustedHours = isPM && hours !== 12 ? hours + 12 : (hours === 12 && period === 'AM' ? 0 : hours);
    
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
      
    return `${year}-${month}-${day} ${String(adjustedHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:00`;
  }
  const date = new Date(startTime);
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const period = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
}
const formatTime = (date: Date) => {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};
const ViewRoute = ({ currentRoute, onRouteChange }: IMapRouterProps) => {
  const [waypoints, setWaypoints] = useState<(Waypoint | null)[]>([null, null]);
  const [isMeetingModalOpen, setIsMeetingModalOpen] = useState(false);
  const [selectedWaypoint, setSelectedWaypoint] = useState<any>(waypoints[1]);
  const [firstStartTime, setFirstStartTime] = useState(formatTime(new Date()));
  const [timesInitialized, setTimesInitialized] = useState(false);
  const apiUrl = process.env.REACT_APP_EAI_URL;
  const { postData } = useExternalApiService(apiUrl);
  const [isGoRouteModalOpen, setIsGoRouteModalOpen] = useState(false);

  const formatDateTimeToAMPM = (dateTimeStr: string) => {
    if (!dateTimeStr) return "";
    
    // Extract time from the datetime string
    const time = dateTimeStr.split(' ')[1];
    const [hours, minutes] = time.split(':').map(Number);
    
    // Convert to 12-hour format
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    
    // Return formatted time
    return `${String(displayHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
  }

  const handleRoutes = (opt: string) => {
    switch (opt) {
      case 'google':
        OpenMapsNavigation()
        break;
      case 'waze':
        OpenWazeNavigation()
        break;
      case 'apple':
        OpenAppleMapsNavigation()
        break;
    }
    setIsGoRouteModalOpen(false)
  }

  const OpenMapsNavigation = () => {
    console.log('selectedWaypoint', selectedWaypoint);
    
    // Check if we have a selected waypoint
    if (!selectedWaypoint || !selectedWaypoint.latitude || !selectedWaypoint.longitude) {
      console.log('No selected waypoint or missing coordinates');
      return;
    }

    // Build Google Maps URL for the current waypoint only
    const url = `https://www.google.com/maps/dir/?api=1&destination=${selectedWaypoint.latitude},${selectedWaypoint.longitude}`;
    // Open in new tab
    window.open(url, '_blank');
  }
  const OpenWazeNavigation = () => {
    console.log('selectedWaypoint', selectedWaypoint);

    // Check if we have a selected waypoint
    if (!selectedWaypoint || !selectedWaypoint.latitude || !selectedWaypoint.longitude) {
      console.log('No selected waypoint or missing coordinates');
      return;
    }

    // Navigate to destination directly (iOS-compatible)
    const url = `https://waze.com/ul?ll=${selectedWaypoint.latitude},${selectedWaypoint.longitude}&navigate=yes`;
    window.open(url, '_blank');
  }

  const OpenAppleMapsNavigation = () => {
    console.log('selectedWaypoint', selectedWaypoint);

    // Check if we have a selected waypoint
    if (!selectedWaypoint || !selectedWaypoint.latitude || !selectedWaypoint.longitude) {
      console.log('No selected waypoint or missing coordinates');
      return;
    }

    // Navigate to destination directly (iOS-compatible)
    const url = `maps://?daddr=${selectedWaypoint.latitude},${selectedWaypoint.longitude}`;
    console.log('Apple Maps url', url);
    window.open(url, '_blank');
  }

  React.useEffect(() => {
    onRouteChange(waypoints?.filter((w) => w)?.length || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waypoints])

  React.useEffect(() => {
    console.log("first useEffect");
    firstStartTimeUpdate(parseStartTime(store.selectedPractitioners[0]?.start_time));
    if(currentRoute?.practitioner_ids && store.selectedPractitioners.length === 0) {
      const getPractitioners = async () => {
        const practitioners = await Promise.all(
          currentRoute.practitioner_ids.map(async (id: number) => {
            const response = await postData('/api/get_practitioner_by_id', {
              practitioner_id: id
            });
            return response.practitioner;
          })
        );
        let firstLocation: any = null;
        let lastLocation: any = null;

        if (currentRoute.locations[0].is_starting_location === "1") {
          firstLocation = {
            address: currentRoute.locations[0].address,
            latitude: currentRoute.locations[0].latitude,
            longitude: currentRoute.locations[0].longitude,
            isFirstLocation: true,
            start_time: currentRoute.locations[0]?.start_time
          }
        } 
        if (currentRoute.locations[currentRoute.locations.length - 1].is_ending_location === "1") {
          lastLocation = {
            address: currentRoute.locations[currentRoute.locations.length - 1].address,
            latitude: currentRoute.locations[currentRoute.locations.length - 1].latitude,
            longitude: currentRoute.locations[currentRoute.locations.length - 1].longitude,
            isLastLocation: true
          }
        }
        // Update both waypoints and store
        const startedWaypoints = [firstLocation, ...(
            practitioners
              .map((p, practitionerIndex) => {
                const defaultAddress = p.addresses?.find((a: any) => a.id === p.default_address);
                // Calculate the actual index in currentRoute.locations
                // If there's a firstLocation, practitioner 0 maps to location 1
                // const locationIndex = firstLocation ?  : practitionerIndex;
                const routeLocation = currentRoute.locations[practitionerIndex + 1];

                return {
                  ...defaultAddress, // Keep address info for display
                  ...p, // Keep practitioner info
                  // CRITICAL: Use coordinates from the route, not from the practitioner's address
                  latitude: routeLocation.latitude,
                  longitude: routeLocation.longitude,
                  address: routeLocation.address, // Use route's address as source of truth
                }
              })
        ), lastLocation].map((waypoint: any, index: number) => {
          console.log("waypointx",waypoint)
          if(waypoint) {
            waypoint.start_time = currentRoute.locations[index].start_time;
            waypoint.duration = parseInt(currentRoute.locations[index].duration);
            return waypoint;
          }
          return null; // Explicitly return null when waypoint is falsy
        });
        console.log("startedWaypoints",startedWaypoints)
        setWaypoints(startedWaypoints.filter(wp => wp !== null));

        store.setSelectedPractitioners(startedWaypoints.filter(wp => wp !== null));
      };
      getPractitioners();
    }else{
     setWaypoints(store.selectedPractitioners);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRoute]);

  // Add useEffect to update waypoints when selectedPractitioners changes
  React.useEffect(() => {
    // Only run this effect if currentRoute is already loaded and we have selectedPractitioners
    if (store.selectedPractitioners.length > 0 && !currentRoute?.is_loading) {
 
      let firstLocation: any = null;
      let lastLocation: any = null;
      if (store.selectedPractitioners[0]?.isFirstLocation) {
        firstLocation = {
          address: store.selectedPractitioners[0]?.address,
          latitude: store.selectedPractitioners[0]?.latitude,
          longitude: store.selectedPractitioners[0]?.longitude,
          isFirstLocation: true,
          travelTime: store.selectedPractitioners[0].travelTime,
          start_time: store.selectedPractitioners[0]?.start_time
        }
      } 
      if (store.selectedPractitioners[store.selectedPractitioners.length - 1]?.isLastLocation) {
        lastLocation = {
          address: store.selectedPractitioners[store.selectedPractitioners.length - 1]?.address,
          latitude: store.selectedPractitioners[store.selectedPractitioners.length - 1]?.latitude,
          longitude: store.selectedPractitioners[store.selectedPractitioners.length - 1]?.longitude,
          isLastLocation: true,
          arriveTime: store.selectedPractitioners[store.selectedPractitioners.length - 1].arriveTime
        }
      }
      // Update waypoints with current first/last locations and all practitioners
      console.log("firstLocation",firstLocation)
      setWaypoints([firstLocation, ...store.selectedPractitioners.filter(p => !p?.isFirstLocation && !p?.isLastLocation), lastLocation]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.selectedPractitioners, currentRoute]);

  // Add useEffect to initialize times when practitioners change
  React.useEffect(() => {
    const wp = waypoints.filter(wp => wp !== null);
    if (wp.length >= 2 && !timesInitialized) {
      console.log("optimizing route");
      setTimesInitialized(true);
      setTimeout(() => {
      setTimesInitialized(false);
      }, 1000);
    } else if (wp.length < 2) {
      console.log("not optimizing route");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [waypoints]);

  const checkDuration = () => {
    if(!currentRoute){
      const currentDuration = waypoints.find((waypoint: any) => waypoint?.id === selectedWaypoint?.id)?.duration;
      if (currentDuration) {
        if (parseInt(currentDuration) < 60) {
          return `${currentDuration} mins`;
        } else {
          const hours = parseInt(currentDuration) / 60;
          return `${hours} hours`;
        }
      }
      return '15 mins';
    }
    const currentDuration = store.selectedPractitioners?.find((practitioner: any) => practitioner.id === selectedWaypoint.id)?.duration;
    if (!currentDuration) return '15 mins';
    if (currentDuration < 60) {
      return `${currentDuration} mins`;
    } else {
      const hours = currentDuration / 60;
      return `${hours} hours`;
    }
  }

  const checkStartTime = () => {
    if(!currentRoute){
      const currentStartTime = selectedWaypoint?.start_time;
      if (currentStartTime) {
        return formatDateTimeToAMPM(currentStartTime);
      }
      return '';
    }
    const currentStartTime = store.selectedPractitioners?.find((practitioner: any) => practitioner.id === selectedWaypoint.id)?.start_time;

    return currentStartTime?formatDateTimeToAMPM(currentStartTime):'';
  }

  const parseLength = (length: number) => {
    if (!length) return '15m';
    if (length < 60) {
      return `${length} m`;
    } else {
      const hours = length / 60;
      return `${hours} h`;
    }
  }
  const renderMeetingModal = () => {
    if (!selectedWaypoint) return null;
    return (
      <MeetingModal
        isOpen={isMeetingModalOpen}
        practitioner={selectedWaypoint}
        onClose={() => {
          setIsMeetingModalOpen(false);
          setSelectedWaypoint(null);
        }}
        updatePractitioner={updatePractitioner}
        checkDuration={checkDuration}
        checkStartTime={checkStartTime}
        setGoRouteModalIsOpen={setIsGoRouteModalOpen}
      />
    );
  }

  const updatePractitioner = async (practitionerId: number, updateData: any) => {
    // Update the waypoint in the local state while preserving order
    const updatedWaypoints = waypoints.map(wp => {
      if (wp === null) return wp;
      const {arriveTime, ...wpWithoutArriveTime} = wp;
      return wp.id === practitionerId 
        ? { ...wpWithoutArriveTime, duration: updateData.meeting_duration, start_time: updateData.start_time ? parseStartTime(updateData.start_time) : ""}
        : wpWithoutArriveTime;
    });
    store.setSelectedPractitioners(updatedWaypoints.filter(wp => wp !== null));
    setWaypoints(updatedWaypoints);
    
    // Update store with the same order as waypoints
  };

  const displayTime = (waypoint: any) => {
    if(waypoint.arriveTime && waypoint.arriveTime !== "") {
      return waypoint.arriveTime;
    }
    if(waypoint.start_time && waypoint.start_time !== "") {
      return parseStartTime(waypoint.start_time);
    }
    return formatTime(new Date());
  }

  const Item = ({ id, waypoint, arriveTime, index, onClick }: { id: number, waypoint: any, arriveTime: string, index: number, onClick: () => void }) => {
    const notNullWaypoint = waypoints.filter(wp => wp !== null);
    return (
      <div
        onClick={() => {
          setSelectedWaypoint(waypoint);
          setIsMeetingModalOpen(true);
        }}
      >
        <div key={waypoint?.id}>
          <div className={styles.waypointSubWrapper}>
            <div
              key={waypoint?.id}
              className={styles.waypointWapper}
            >
              <div className={styles.waypointInfo}>
                <p className={styles.headerText}>{index + (waypoints[0]? 2 : 1)}. {waypoint?.name || waypoint?.primary_name || ""}</p>
                <div className={styles.travelTextContainer}>
                  <p className={styles.timeText}>{displayTime(waypoint)}</p>
                  <div className={styles.travelLengthContainer}>  
                    Length:
                    <p className={styles.travelLengthText}>{parseLength(waypoint?.duration)}</p>
                  </div>
                </div>
              </div>
              <div className={styles.expandIconContainer}>
                <ExpandIcon width={16} height={16} />
              </div>
            </div>
            {!isNaN(waypoint?.travelTime) && waypoint.id !== notNullWaypoint[notNullWaypoint.length - 1]?.id  && (
              <div className={styles.custonSplitter}>
                <div className={styles.travelTime}>
                  <p className={styles.travelTimeText}>Travel Time: {waypoint.travelTime} minutes</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  const firstStartTimeUpdate = (startTime: string) => {
      const firstWaypoint = waypoints.filter(wp => wp !== null)[0];
      console.log("firstWaypoint",firstWaypoint)
      setFirstStartTime(startTime);
      if (firstWaypoint) {
        firstWaypoint.start_time = startTime ? parseStartTime(startTime) : (firstStartTime ? firstStartTime : "");
        setWaypoints([firstWaypoint, ...waypoints.slice(1)]);
        store.setSelectedPractitioners([firstWaypoint, ...store.selectedPractitioners.slice(1)]);
     
      }
  }
  return (
    <div className={styles.currentRouteContainer}>
      {renderMeetingModal()}
      <div className={styles.searchContainer}>
        {!waypoints[0] ? (waypoints.length > 2 ? (
          
          <div className={styles.searchInput}>
            <HouseIcon width={'25px'} height={'25px'} style={{marginRight: '15px',}}/>
            <span className={styles.placeholder}>Starting location</span>
          </div>
        ): null) : (
          <div className={styles.firstLocationContainer}>
            <div className={styles.locationContainer}>
              <div className={styles.locationNumber}>1.</div>
              <span className={styles.locationAddress}>{waypoints[0].address}</span>              
            </div>
            <div style={{display:'flex'}}>
              <div className={styles.timeText}>
                {firstStartTime ? (firstStartTime) : formatTime(new Date())}
              </div>
            </div>
            {waypoints[0]?.travelTime ? (
              <div className={`${styles.custonSplitter} ${styles.firstLocationSplitter}`}>
                <div className={styles.travelTime}>
                  <p className={styles.travelTimeText}>Travel Time: {waypoints[0]?.travelTime} minutes</p>
                </div>
              </div>
            ) : null}
          </div>
        )}
      </div>
      <div>
        {waypoints.slice(1, -1).map((waypoint, index) => (
          <Item 
            key={index+1}
            id={index+1}
            waypoint={waypoint}
            arriveTime={waypoint?.arriveTime || ""}
            index={index}
            onClick={() => {}}
          />
        ))}
      </div>
      {!waypoints[waypoints.length - 1] ?
        (waypoints.length > 2 ? (
          <div className={styles.searchInput}>
            <FlagIcon width={'20px'} height={'20px'} style={{paddingLeft: '4px', marginRight: '15px'}}/>
            <span className={styles.placeholder}>Ending location</span>
          </div>
        ) : null
      ) : (
        <div className={styles.firstLocationContainer}>
          <div className={styles.locationContainer}>
            <div className={styles.locationNumber}>{store.selectedPractitioners.length}.</div>
            <span className={styles.locationAddress}>{waypoints[waypoints?.length - 1]?.address}</span>
          </div>
          <div style={{display:'flex'}}>
            <div className={styles.timeText}>
              {waypoints[waypoints.length - 1]?.arriveTime}
            </div>
          </div>
        </div>
      )}

      <RoutesTab isOpen={isGoRouteModalOpen} setIsOpen={setIsGoRouteModalOpen} onSelect={handleRoutes} />
    </div>
  );
};

export default ViewRoute;